const formatTime = date => {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hour = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()

  return [year, month, day].map(formatNumber).join('/') + ' ' + [hour, minute, second].map(formatNumber).join(':')
}

const formatNumber = n => {
  n = n.toString()
  return n[1] ? n : '0' + n
}


const formatSeconds = theTime => {
  let theTime1 = 0
  let theTime2 = 0
  if (theTime > 60) {
    theTime1 = parseInt(theTime / 60)
    theTime = parseInt(theTime % 60)
    if (theTime1 > 60) {
      theTime2 = parseInt(theTime1 / 60)
      theTime1 = parseInt(theTime1 % 60)
    }
  }
  let result = '' + parseInt(theTime) + '秒'
  if (theTime1 > 0) {
    result = '' + parseInt(theTime1) + '分' + result
  }
  if (theTime2 > 0) {
    result = '' + parseInt(theTime2) + '小时' + result
  }
  return result
}

// const pictureBaseUrl = ;

// const pictureBaseUrl = process.env.NODE_ENV === 'production' ? 'https://oss-miaojiangmin.oss-cn-hangzhou.aliyuncs.com/zjzc789/' : '../../'
const pictureBaseUrl = process.env.NODE_ENV === 'production' ? 'https://oss-miaojiangmin.oss-cn-hangzhou.aliyuncs.com/zjzc789/static' : '/static'

// const pictureBaseUrl = process.env.NODE_ENV === 'production' ? '/static' : '/static'


module.exports = {
  formatSeconds: formatSeconds,
  formatTime: formatTime,
  pictureBaseUrl: pictureBaseUrl,
}


// WEBPACK FOOTER //
// ./src/utils/global.js